import { render, staticRenderFns } from "./LevelCompleted.vue?vue&type=template&id=3889a04b&scoped=true"
import script from "./LevelCompleted.vue?vue&type=script&lang=js"
export * from "./LevelCompleted.vue?vue&type=script&lang=js"
import style0 from "./LevelCompleted.vue?vue&type=style&index=0&id=3889a04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889a04b",
  null
  
)

export default component.exports